import { Form } from "react-bootstrap"

import BottomSheet from "../../../components/_modals/BottomSheet"
import { TitleH3 } from "../../../components/TitleH3"
import { Text } from "../../../components/Text"
import { Button } from "../../../components/Button"
import { moduleTotal, renderTopicGroupLabel } from "../examUtils"

export default function ExamCustomizeTopicsSheet ({ isOpen, moduleName, rows, topicsMap, t, onToggleAll, onToggleRow, onValueChange, onSave, onCancel }) {

    if (!rows) return null

    const activeCount = rows.filter(row => row.enabled).length

    return (
        <BottomSheet isOpen={isOpen} onClose={onCancel} showExit={false}>
            <div className="px-2 px-md-3">
                <TitleH3 className="text-center">{moduleName}</TitleH3>
                <Text className="text-center">{t.exam.customize.sheet_title}</Text>

                {rows.length > 1 &&
                    <Form.Check
                        type="checkbox"
                        className="mt-3"
                        label={t.exam.customize.select_all_topics}
                        checked={rows.every(row => row.enabled)}
                        onChange={onToggleAll}
                    />
                }

                {rows.map((row, rowIndex) => (
                    <div className="exam_customize_topic_row mt-3" key={rowIndex}>
                        <Form.Check
                            type="checkbox"
                            checked={row.enabled}
                            disabled={row.enabled && activeCount <= 1}
                            onChange={() => onToggleRow(rowIndex)}
                        />
                        <div className="exam_customize_topic_row__label">
                            <Text className={`mb-0 ${!row.enabled ? 'text-muted' : ''}`}>{renderTopicGroupLabel(row, topicsMap)}</Text>
                            <small className="text-muted">{t.exam.customize.max_questions.replace('{max}', row.max)}</small>
                        </div>
                        <Form.Control
                            type="number"
                            min={0}
                            max={row.max}
                            value={row.value}
                            disabled={!row.enabled}
                            style={{ width: "80px" }}
                            onChange={(e) => onValueChange(rowIndex, e.target.value)}
                        />
                    </div>
                ))}

                <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                    <Text className="mb-0">{t.exam.customize.total_label}</Text>
                    <Text className="mb-0">{moduleTotal(rows)} {t.exam.customize.questions_unit}</Text>
                </div>

                <div className="mt-3 mb-2">
                    <Button className="mx-auto" onClick={onSave}>{t.exam.customize.save}</Button>
                    <Button color="secondary" className="mx-auto mt-2" onClick={onCancel}>{t.exam.customize.cancel}</Button>
                </div>
            </div>
        </BottomSheet>
    )
}
